/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Debaloy Chatterjee',
        title: 'Web Developer',
        text: "Your leadership, wisdom, and commitment to excellence inspire us all. Wishing you a joyful, healthy milestone birthday, celebrating the legacy you\'ve built and lives you\'ve impacted.",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIghc4Hwc7CmQWNsFHaYVUNsX45imvIIx99g&s"
    },
    {
        id: 2,
        name: 'Aroop Chatterjee',
        title: 'COPA ITI Student',
        text: "Happy Birthday Dr. Datta. The journey with you has always been motivational. You are the best and keep inspiring others.🙏🥳",
        image: boy1
    },
    {
        id: 3,
        name: 'Anjali',
        title: 'MERIT Faculty',
        text: "Your guidance and mentorship have made a lasting impact on my life. Your life shows us that age is just a number, but wisdom, love, and kindness are timeless. May your birthday mark a new chapter of joy, purpose and fulfilment.",
        image: "https://media-del2-2.cdn.whatsapp.net/v/t61.24694-24/325966864_613260697597936_7936212137640761671_n.jpg?ccb=11-4&oh=01_Q5AaIMfP_WeMRMiIls3esjqr9bvgdm7rjOv4BUEaclthN69z&oe=6736DAE5&_nc_sid=5e03e0&_nc_cat=103"
    },
    {
        id: 4,
        name: 'Meenakshi Sharma',
        title: 'MERIT Faculty',
        text: "Wish you a very happy birthday sir. On your special day, I would like to thank you a lot for all the support, dedication and inspiration that you have parted to us. Once again thank you for never letting us down.",
        image: "https://media-del2-2.cdn.whatsapp.net/v/t61.24694-24/453614646_1177599946906613_7582120605303743303_n.jpg?ccb=11-4&oh=01_Q5AaIEWaVfTJJmJfWwZVHkgQ0M4H2KCjshRMhw-j_O6SNFoV&oe=6736DC81&_nc_sid=5e03e0&_nc_cat=110"
    },
    {
        id: 5,
        name: 'Meenakshi Thakur',
        title: 'MERIT Faculty',
        text: "Happy 90th Birthday! Your wisdom, dedication, and leadership have been an inspiration, leaving a lasting impact on all of us at MERIT. It\'s been a privilege to learn from you. Wishing you health, happiness, and continued success!",
        image: "https://media-del2-2.cdn.whatsapp.net/v/t61.24694-24/311329632_465142092382245_1718672502662673983_n.jpg?ccb=11-4&oh=01_Q5AaIH3p6Sd9UpllA6s52lOSGP-9MHh7EkLyDdKomzRVrSY5&oe=6736D9D5&_nc_sid=5e03e0&_nc_cat=109"
    },
    {
        id: 6,
        name: 'Tusar Ranjan Sarangi',
        title: 'MERIT Faculty',
        text: "Today, we celebrate not only your birthday but the profound impact you\'ve had on us all. As a guide, mentor, and source of inspiration, your dedication and support drive us to be our best. Wishing you good health, happiness, and heartfelt thanks for your incredible leadership.",
        image: "https://gicseh.com/images/teachers/tusar.jpg"
    },
    {
        id: 7,
        name: 'Rahimuddin Ansari',
        title: 'MERIT Faculty',
        text: "I am so happy to get to celebrate with you on your special day! May God continue to enrich you with knowledge, wisdom, and understanding as you continue leading our team. Wishing you a very happy birthday!",
        image: "https://media-del2-2.cdn.whatsapp.net/v/t61.24694-24/461245675_567155069158036_4519464378537428516_n.jpg?ccb=11-4&oh=01_Q5AaIM1G6HjoEOzNmBueWsjxdgvzcRhWpqDop5M6LeiWjqON&oe=6736C07A&_nc_sid=5e03e0&_nc_cat=103"
    },
    {
        id: 8,
        name: 'John Priyam',
        title: 'MERIT Faculty',
        text: "Congratulations to Dr. Rattan K. Datta, esteemed Director of MERIT Institute, on his 90th birthday! Your dedication and visionary leadership continue to inspire and uplift us. Wishing you continued health and happiness!",
        image: "https://media-del2-2.cdn.whatsapp.net/v/t61.24694-24/465380670_1077827843811080_4473679583486993730_n.jpg?ccb=11-4&oh=01_Q5AaIFlsOY69yw28WnG3XjYlDlUNG3mD5KtQgjyaGpsSPln4&oe=6736EB9F&_nc_sid=5e03e0&_nc_cat=107"
    },
    {
        id: 9,
        name: 'Meena Datta',
        title: 'Principal - MERIT',
        text: "Happy birthday to my Bahu mulya Ratan…..most valuable senior person in sadda pariwar. My sweet 16 bittoo I wish you have healthy life. You are the big healer of yourself and others. You set yourself  as an example to others in any field. Waiting for 100 years ♥👍 Big cheeeeers for 90 ….which is running. Celebrate your Day. 👍♥🌹🎂🍰🎁💞❣💕💝",
        image: "https://media-del2-1.cdn.whatsapp.net/v/t61.24694-24/454275998_8805255009490115_2580299110825497598_n.jpg?ccb=11-4&oh=01_Q5AaINodF0xX_7m3nERWfTpxMvcNlVu6ywo5qEKBT-XLMCR5&oe=67374C7E&_nc_sid=5e03e0&_nc_cat=102"
    },
    {
        id: 10,
        name: 'Rohan Choudhary',
        title: 'MERIT Faculty',
        text: "At 90, he stands as a beacon of wisdom and strength—an inspiring mentor, a dedicated teacher, and an unwavering leader. As the director of the institution, his guidance shapes futures, while his discipline in health reflects the vitality of a life well-lived. A true admiral, steering both his students and himself towards greatness.",
        image: "https://media-del2-1.cdn.whatsapp.net/v/t61.24694-24/455836375_912200930304461_3212108628170685659_n.jpg?ccb=11-4&oh=01_Q5AaIF_STt6CoWNsX8whoELU1He4DDf3QEuqSeDsPgrS6_lM&oe=673763B2&_nc_sid=5e03e0&_nc_cat=105"
    },
    {
        id: 11,
        name: 'Ekta',
        title: '',
        text: "Happy 90th Birthday, daduji! What an incredible milestone to celebrate! Your life is a beautiful story of love, laughter, and resilience. You've seen so much, and through it all, you've remained a constant source of wisdom and strength for all of us. Today, we celebrate YOU. May your day be filled with all the joy you deserve, and may the years ahead be just as blessed and full of love. Here's to many more cherished memories together!",
        image: girl1
    },
]

